import { Lightning } from "@lightningjs/sdk";
export class LiveIndicator extends Lightning.Component {
    static _template() {
        return {
            w: 10,
            h: 10,
            flexItem: { shrink: 0 },
            Ring: {
                w: 10,
                h: 10,
                rect: true,
                shader: {
                    type: Lightning.shaders.RoundedRectangle,
                    radius: 5,
                    stroke: 1,
                    fillColor: 0x00ffffff,
                    strokeColor: 0xffffffff,
                },
            },
            Dot: {
                x: 5,
                y: 5,
                w: 6,
                h: 6,
                mount: 0.5,
                rect: true,
                color: 0xffffffff,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 3 },
            },
        };
    }
    set size(size) {
        const dotSize = size * 0.6;
        this.patch({
            w: size,
            h: size,
            Ring: {
                w: size,
                h: size,
                shader: { radius: size / 2, stroke: size * 0.1 },
            },
            Dot: {
                x: size / 2,
                y: size / 2,
                w: dotSize,
                h: dotSize,
                shader: { radius: dotSize / 2 },
            },
        });
    }
    set indicatorColor(color) {
        this.patch({
            Ring: { shader: { strokeColor: color } },
            Dot: { color },
        });
    }
}
export default LiveIndicator;
//# sourceMappingURL=LiveIndicator.js.map